import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  data: null,
  filteredTotal: 0,
  filters: [],
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, savedSearches } = payload;

  return {
    ...state,
    data,
    filteredTotal,
    filters,
    loading: false,
    total,
    savedSearches,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
